<template>
  <wt-table :isSelect="isSelect" :reserve-selection="true" :list="currentTable" :labels="tableLabels" @selection-change="handleSelectionChange" @select="handelRowSelect" @select-all="handleSelectAll" @row-click="handleRowClick" :row-key="getRowKeys" ref="multipleTable">
    <template>
      <el-table-column label="" v-if="showDelete">
        <template slot-scope="scope">
          <el-button @click="handleDelete(scope.row)" type="text">移除</el-button>
        </template>
      </el-table-column>
      <el-table-column label="详情" v-if="!showDelete && status!=='CREATE'" fixed="right">
        <template slot-scope="scope">
          <el-button @click="goDetail(scope.row.orderActionData.order.id)" type="text">详情</el-button>
        </template>
      </el-table-column>
      <slot />
    </template>
  </wt-table>
</template>

<script>
export default {
  props: {
    isSelect: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentTable: this.tableData
    }
  },
  watch: {
    tableData (val) {
      this.currentTable = val
    }
  },
  methods: {
    clearSelection () {
      this.$refs.multipleTable.clearSelection()
    },
    getRowKeys (row) {
      return row.id
    },
    handleSelectionChange (val) {
      this.selected = val
      this.$emit('updateSelectedData', val)
    },
    handleRowClick (row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row)
      this.handelRowSelect(this.selected, row)
    },
    handelRowSelect (rows, row) {
      let selected = Boolean(rows.length && rows.indexOf(row) !== -1)
      if (selected) {
        this.commonFun(rows, [row])
      }
    },
    handleSelectAll (selection) {
      this.commonFun(selection, this.tableData)
    },
    /**
     * selection:当前所有选中的数据
     * deleteDatas:如果有不满足条件的需要取消选中的数据
     * isAll：是否是全选
     */
    commonFun (selection, deleteDatas) {
      if (selection && selection.length) {
        let nextAction = Array.from(new Set(selection.map(e => e.orderActionData.nextAction)))
        let acceptableResults = Array.from(new Set(selection.map(e => e.orderActionData.futureActionAcceptableResults.toString())))
        if (nextAction.length > 1) {
          // nextAction一致
          this.$message.error('勾选的多个样本所属“异常步骤”须一致！')
          this.handleDeleteDatas(deleteDatas)
        }
        if (acceptableResults.includes('SAMPLE_RECOLLECT')) {
          // 有创建重采订单的删除
          this.$message.error('您选中的有“创建重采订单”，不能进行批量处理！')
          this.handleDeleteDatas(deleteDatas)
        }
      }
    },
    handleDeleteDatas (rows) {
      rows.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row, false)
      })
    },
    handleDelete (row) {
      this.$confirm('确定要移除该条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.currentTable = this.currentTable.filter(e => e.id !== row.id)
        this.$emit('deleteRow', row)
      })
    },
    goDetail (orderId) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'lab-order-detail', params: { id: orderId } })
    }
  }
}
</script>

<style>
</style>
